module.exports = __webpack_public_path__ + "img/device-locked-icon.0feaa941.svg";